import React from 'react';
import d3 from 'd3';


export default class HtmlTooltip extends React.Component {
    render() {    
        
            /*if(this.props.tooltipFormatter) {
                return {
                    xval: dataobj.series[minindex][0],
                    yval: dataobj.series[minindex][1],
                    text: this.props.tooltipFormatter(dataobj.name, dataobj.series[minindex][0], dataobj.series[minindex][1]),
                    pointdistance: pointdistance,
                    color: dataobj.color || null
                }    
            } else {
                return {
                    xval: dataobj.series[minindex][0],
                    yval: dataobj.series[minindex][1],
                    text: dataobj.name + ": " + dataobj.series[minindex][1],
                    pointdistance: pointdistance,
                    color: dataobj.color || null
                }
            }*/
                
        return <div 
                className = "chartTooltip"
                style ={{
                    position:"absolute",
                    left:this.context.mouseX+"px", 
                    top:this.context.mouseY+"px"
                }}>
                <div style={{position:"relative"}}>
                    <div style={{
                        width:(this.props.tooltipwidth || 100)+"px",
                        zIndex:1000
                    }}>
                        {this.props.children}    
                    </div>
                </div>
            </div>
    
    }
}
/*visibility: tooltiptextarr.length>0?'visible':'hidden'*/
/*{tooltiptextarr.map((val) => <p style={{color:val.color}}>{val.text}</p>)}*/
/*{getTooltipTitle(this.props,closestx)}*/
HtmlTooltip.contextTypes = {
    mouseX: React.PropTypes.number,
    mouseY: React.PropTypes.number
};


// WEBPACK FOOTER //
// ./src/js/components/charting/HtmlTooltip/HtmlTooltip.jsx